import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import ParentCompanySection from "../components/ParentCompanySection";
import { ArrowLeft, ArrowRight } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=2000";

export default function ParentCompanyPage() {
  return (
    <div className="App" data-testid="parent-company-page">
      <Navbar />
      {/* Mini hero */}
      <section className="relative overflow-hidden border-b border-[#1a1a1a]">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/85 to-black" />
        <div className="relative max-w-7xl mx-auto px-6 py-20">
          <Link to="/" className="text-sm text-[#a3a3a3] inline-flex items-center gap-2 hover:text-white mb-8" data-testid="back-home">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
          <p className="overline">Parent Company</p>
          <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter text-white mt-4 uppercase leading-[0.95] text-balance">
            Trawell <span className="text-brand">DMC</span><br />
            <span className="text-[#a3a3a3]">Curating amazing — since 2005.</span>
          </h1>
          <p className="text-lg text-[#a3a3a3] mt-6 max-w-2xl leading-relaxed">
            The Dubai-headquartered destination management company powering TrawellB2B.
            Two decades, 140,000+ travellers, seven destinations across South-East Asia and West Asia.
          </p>
          <div className="flex flex-wrap items-center gap-4 mt-9">
            <Link to="/register" className="btn-primary" data-testid="parent-cta-register">
              Join the network <ArrowRight className="w-4 h-4" />
            </Link>
            <a href="https://trawellb2b.com" target="_blank" rel="noopener noreferrer" className="btn-ghost">
              Visit trawellb2b.com →
            </a>
          </div>
        </div>
      </section>

      <ParentCompanySection />
    </div>
  );
}
